export default __webpack_public_path__ + "images/2U.27b6cba.png";